<script lang="ts" setup>
import ElTableOrganization from './components/ElTable/ElTableOrganization.vue'
</script>

<template>
    <el-card shadow="never">
        <ElTableOrganization />
    </el-card>
</template>

<style lamg="scss" scoped></style>
